import { SetAfterProfilePanel } from './general.types';

const setAfterProfilePanelUrl = (url: string): SetAfterProfilePanel => ({
  type: 'SET_AFTER_PROFILE_PANEL_URL',
  payload: url,
});

export const generalActions = {
  setAfterProfilePanelUrl,
};
